import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyMember} from '../../../graphql/groups.datatypes';
import {gqlRoomPartyMember} from '../../GroupBookings/getGroupBooking.api';

interface DeleteRoomPartyMemberInput {
    id: number
}

interface DeleteRoomPartyData {
    deleteRoomPartyMember: RoomPartyMember
}

export const DELETE_ROOM_PARTY_MEMBER_MUTATION = gql`
    mutation deleteRoomPartyMember($id: Int!) {
        deleteRoomPartyMember(id: $id) {
            ${gqlRoomPartyMember}
        }
    }
`;

export const deleteRoomPartyMember = () => useMutation<DeleteRoomPartyData, DeleteRoomPartyMemberInput>(
    DELETE_ROOM_PARTY_MEMBER_MUTATION,
    {
        update: updateCacheByType('RoomPartyMember'),
    }
);

export default deleteRoomPartyMember;